var tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

if (!customElements.get("shankou-video")) {
  customElements.define(
    "shankou-video",
    class ShankouVideo extends HTMLElement {
      constructor() {
        super();
      }
      initialize() {
        this.player = new YT.Player(this.dataset.videoId, {
          videoId: "gLZOVXE2kQs",
          events: {},
        });

        this.btn.addEventListener("click", () => {
          this.video.classList.add("active");
          document.body.classList.add("overflow-hidden");
          setTimeout(() => {
            this.content.classList.add("active");
            this.player.playVideo();
          }, 100);
        });

        this.close.addEventListener("click", () => {
          this.video.classList.remove("active");
          document.body.classList.remove("overflow-hidden");
          this.content.classList.remove("active");
          this.player.stopVideo();
        });
      }
      connectedCallback() {
        this.video = this.querySelector(".section-exit-pop-video");
        this.content = this.querySelector(".content");
        this.btn = this.querySelector(".video-link");
        this.close = this.querySelector(".content .close-exit-pop");
        this.player = null;
        this.interval = setInterval(() => {
          if (window.YT && window.YT.Player) {
            clearInterval(this.interval);
            this.initialize();
          }
        }, 1000);

        function onYouTubeIframeAPIReady() {}
        // $(
        //   ".section-openfit2-video-img .openfit2-video-img-wrapper .video-wrapper .video-link",
        // ).click(function () {
        //   $(".section-exit-pop-video-img-1").addClass("active");
        //   $("body").addClass("overflow-hidden");
        //   setTimeout(function () {
        //     $(".section-exit-pop-video-img-1 .content").addClass("active");
        //     player.playVideo();
        //   }, 100);
        // });
        // $(".section-exit-pop-video-img-1 .content .close-exit-pop").click(
        //   function () {
        //     $(".section-exit-pop-video-img-1").removeClass("active");
        //     $("body").removeClass("overflow-hidden");
        //     $(".section-exit-pop-video-img-1 .content").removeClass("active");
        //     player.stopVideo();
        //   },
        // );
      }
    },
  );
}

$(function () {
  $('.options-color-wrapper:not([data-title="山口一郎モデル "])').click(
    function () {
      $(".shankou-listing-only-part").removeClass("active");
      $(".shankou-listing-hide").addClass("active");
      $(".festival-product-page-info").addClass("active");
    },
);
$('[data-title="山口一郎モデル "]').click(function () {
      $(".festival-product-page-info").removeClass("active");
    $(".shankou-listing-hide").removeClass("active");
    $(".shankou-listing-only-part").addClass("active");
  });
  
  // $('.options-color-wrapper[data-title="山口一郎モデル "]').click();
});
